"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerExcelReportColumnName = void 0;
var ProducerExcelReportColumnName;
(function (ProducerExcelReportColumnName) {
    ProducerExcelReportColumnName["producerId"] = "Producer ID";
    ProducerExcelReportColumnName["clientName"] = "Client Name";
    ProducerExcelReportColumnName["clientType"] = "Client Type";
    ProducerExcelReportColumnName["emailBounceRate"] = "Email Bounce Rate";
    ProducerExcelReportColumnName["emailsSent"] = "Emails Sent";
    ProducerExcelReportColumnName["firstEventDate"] = "First Event Date";
    ProducerExcelReportColumnName["eventDate"] = "Event Date";
    ProducerExcelReportColumnName["eventName"] = "Event Name";
    ProducerExcelReportColumnName["numberOfParticipants"] = "Number of Participants";
    ProducerExcelReportColumnName["primaryContactName"] = "Primary Contact Name";
    ProducerExcelReportColumnName["primaryContactEmail"] = "Primary Contact Email";
})(ProducerExcelReportColumnName = exports.ProducerExcelReportColumnName || (exports.ProducerExcelReportColumnName = {}));
//# sourceMappingURL=producer-excel-report-column-names.js.map